import {createMuiTheme} from "@material-ui/core";
import {darken} from "@material-ui/core/styles/colorManipulator";

const colors = {
    primary: '#B4B4B6',
    secondary: '#ffffff',
    error: '#f86666',

    white: '#ffffff',
    black: '#000000',
    paleGray: '#f8f9fb',
    darkPaleGray: darken('#f8f9fb', 0.6),
    iceBlue: '#e5f0ff',
    lightGreyBlue: '#9fa9bc',
    offWhite: '#feffdd',
    highlightText: darken('#feffdd', 0.3),
};

const oneLiner = {
    display: "block",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
};

// We expose the default theme to have a 'theme'
// variable build on, like we have using withStyles()
const defaultTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
});

export default createMuiTheme({
    colors,
    helpers: {
        oneLiner
    },
    typography: {
        useNextVariants: true,
    },
    palette: {
        background: {
            default: colors.paleGray,
        },
        primary: {
            main: colors.primary,
        },
        secondary: {
            main: colors.secondary,
            dark: colors.paleGray,
            contrastText: colors.lightGreyBlue,
        },
        error: {
            main: colors.error,
        },
        action: {
            selected: colors.iceBlue,
            hover: colors.iceBlue,
        },
        vCenter: {
            alignItems: "center",
            display: "flex",
        },
        hCenter: {
            justifyContent: "center",
            display: "flex",
        },
        vhCenter: {
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
        }
    },
    overrides: {
        MuiPaper: {
            root: {
                overflow: 'visible !important'
            }
        },
        MuiAppBar: {
            root: {
                zIndex: defaultTheme.zIndex.drawer + 1,
            },
        },
        MuiCard: {
            root: {
                overflow: "inherit",
            },
        },
        MuiTypography: {
            h2: {
                color: colors.primary,
                fontSize: 20,
                fontWeight: 500,
                textTransform: 'uppercase',
            },
            subtitle2: {
                color: colors.lightGreyBlue,
                fontSize: 12,
                fontWeight: 400,
            },
        },
        MuiExpansionPanel: {
            root: {
                boxShadow: defaultTheme.shadows[0], // remove elevation
                marginTop: defaultTheme.spacing.unit,
                marginBottom: defaultTheme.spacing.unit,
                border: '1px solid #eef1f8',
                borderRadius: '4px',
                '&:before': {
                    content: '', // remove divider
                },
            },
            expanded: {
                border: `1px solid ${colors.lightGreyBlue}`,
            },
        },
        MuiExpansionPanelSummary: {
            root: {
                color: colors.lightGreyBlue,
                fontWeight: 500,
            },
            expandIcon: {
                color: colors.lightGreyBlue,
            },
            expanded: {
                color: '#4d4f5c',
            },
        },
        MuiListItem: {
            root: {
                color: colors.lightGreyBlue,
                '&$selected, &$selected:hover': {
                    color: colors.primary,
                    borderRight: `6px solid ${colors.primary}`
                },
            },
            button: {
                '&:hover': {
                    color: colors.primary,
                    backgroundColor: 'transparent',
                },
            },
        },
        MuiListItemIcon: {
            root: {
                // necessary cause it would overwride our MuiListItem color
                // for the selected state otherwise
                color: 'inherit',
            },
        },
        MuiListItemText: {
            primary: {
                // necessary cause it would overwride our MuiListItem color
                // for the selected state otherwise
                color: 'inherit',
            },
        },
        MuiTabs: {
            root: {
                borderBottom: `1px solid ${colors.paleGray}`,
                color: colors.primary,
                backgroundColor: colors.white,
            },
            indicator: {
                backgroundColor: colors.primary,
            },
        },
        MuiTab: {
            root: {
                color: colors.paleGray,
                '&:hover': {
                    color: colors.primary,
                },
                '&:focus': {
                    color: colors.primary,
                },
            }
        },
        MuiFormControl: {
            root: {
                marginTop: "0.7rem",
                marginBottom: "0.7rem",
            }
        },
        MuiInput: {
            input: {
                padding: '10px 0 7px',
            }
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/Layout/theme.js